/**
 *  Created by piotr@revisual.io on 04/08/2025
 */
import classNames from "classnames";

/**
 *
 * @param {Object} form
 * @param {function} setFormField
 * @param {Object} errors
 * @returns {JSX.Element}
 * @constructor
 */
export const AddWebsiteStep = ({ form, setFormField, errors }) => {
  return (
    <div>
      <h3 className="account-title">Add website domain</h3>
      <p className="text-muted">
        Add website domain where you want to embed your widgets.
      </p>
      <form>
        <div className="form-group">
          <label htmlFor="websiteDomain">Website Domain</label>
          <input
            id="websiteDomain"
            type="text"
            className={classNames("form-control", {
              "is-invalid": errors.websiteDomain,
            })}
            value={form.websiteDomain}
            onChange={setFormField("websiteDomain")}
            placeholder="e.g. example.com"
          />
          <span className={"text-danger"}>{errors.websiteDomain}</span>
        </div>
      </form>
    </div>
  );
};

export default AddWebsiteStep;
